import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DipPickerComponent } from './dip-picker.component';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { ToggleSwitchModule } from '../toggle-switch/toggle-switch.module';
import { TooltipButtonModule } from '../tooltip-button/tooltip-button.module';



@NgModule({
  declarations: [
    DipPickerComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    TranslateModule,
    ToggleSwitchModule,
    TooltipButtonModule,
  ],
  exports: [
    DipPickerComponent,
  ],
  providers: [
    TranslatePipe,
  ],
})
export class DipPickerModule { }
